export const FETCH_DASHBOARD_REQUEST = 'FETCH_DASHBOARD_REQUEST';
export const FETCH_DASHBOARD_SUCCESS = 'FETCH_DASHBOARD_SUCCESS';
export const FETCH_DASHBOARD_FAILURE = 'FETCH_DASHBOARD_FAILURE';

export const CLEAR_DASHBOARD_ERRORS = 'CLEAR_DASHBOARD_ERRORS';
export const CLEAR_DASHBOARD_SUCCESS = 'CLEAR_DASHBOARD_SUCCESS';